import { atom } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';

import type { JSX } from 'react';
import type { APlusData } from './APlus/types';

export const installmentCollapsed = atom(true);
export const selectedQuantity = atom(1);
/**
 * this atom save the aPlusServices
 * the data is used for the add to basket and the tracking of the add to basket
 *
 * IMPORTANT: this atom is not used to display the selected services in the UI!
 */
export const selectedServices = atom<APlusData | null>(null);

export const HydrateAtoms = ({ children }: { children: JSX.Element }) => {
  useHydrateAtoms([
    [selectedQuantity, 1],
    [installmentCollapsed, true],
    [selectedServices, new Map()],
  ]);

  return children;
};
